export default "__VITE_ASSET__CoQBsL8N__"